export default (video) => {
  const matched = video.match(/.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/)

  if (!matched) {
    return undefined
  }

  return matched[1]
}
